import React from "react";
import { useNavigate } from "react-router-dom";
import Popup from "reactjs-popup";

const SignupAsPopup = ({ showSignupAsPopup, setShowSignupAsPopup }) => {
  const navigate = useNavigate();

  const handleClosePopup = () => {
    setShowSignupAsPopup(false);
  };

  return (
    <Popup
      open={showSignupAsPopup}
      onClose={handleClosePopup}
      closeOnDocumentClick={false}
      className="signup-as-popup"
    >
      <div className="signup-as-popup-container">
        <div
          onClick={() => {
            handleClosePopup();
            navigate("/account/create", { state: { accountType: "artist" } });
          }}
        >
          Artist
        </div>
        <div
          onClick={() => {
            handleClosePopup();
            navigate("/account/create", {
              state: { accountType: "artist-representative" },
            });
          }}
        >
          Artist <br /> Representative
        </div>
        <div>Gallery</div>
        <div>Museum</div>
        <div>Buyer</div>
        <div>Donor</div>
        <div>
          Register an <br /> anons
        </div>
        <div>
          Register an <br /> announcement
        </div>
      </div>
    </Popup>
  );
};

export default SignupAsPopup;
